import React from 'react';
import PageGenerator from 'components/page-generator';
import 'styles/main.scss';

// content comes from the src/wp-data/pages.json snapshot (WordPress is gone), also in develop
export default function PageTemplate({ pageContext }) {
  return (
    <main>
      <PageGenerator {...pageContext} featuredList={pageContext.featuredList} />
    </main>
  );
}
